import { Link } from 'react-router-dom';
import { entityDashboardRoutingSwitch } from 'features/navigation/routers/internal_routing';
import { Circle } from '@mui/icons-material';

function breakdownCellProvider(entity: any, idx: number, colors: any[], countKey?: string) {
    const targetUrl =
        entity && entity.entityIdentifier
            ? entityDashboardRoutingSwitch(
                  entity.entityIdentifier.entityType,
                  entity.entityIdentifier
              )
            : null;

    return (
        <div key={idx} className="flex flex-row items-center space-x-2">
            <Circle
                style={{
                    color: colors[idx].primary,
                    fontSize: 14,
                }}
                fontSize="inherit"
            />
            {entity.entityIdentifier && targetUrl ? (
                <Link
                    className="text-sky-600 font-medium text-sm hover:underline"
                    to={targetUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    {entity.entityIdentifier.entityName} ({entity[countKey || 'count']})
                </Link>
            ) : (
                <div style={{ color: colors[idx].primary }} className="font-medium text-sm">
                    {entity.name || entity.entityName} ({entity[countKey || 'count']})
                </div>
            )}
        </div>
    );
}

export default breakdownCellProvider;
